import React, { useEffect, useState } from 'react';
import NoInternetConnectionPage from '../../components-library/internet/NoInternetConnectionPage';
import { RoutesInterface } from '../../services/exports/Interfaces';
import { useSelector } from 'react-redux';
import { EventHelperTypes } from '../../services/exports/Constants';
import HelperMethods from '../../services/exports/HelperMethods';
import AuthRoute from '../../components-library/navigation/middleware/AuthRoute';
import CompanySlugObserver from '../../components-library/navigation/middleware/CompanySlugObserver';
import { StoreInterface } from '../../store/types';
import useNetworkStatus from './useNetworkStatus';

export default function useScreenFallback() {
  const { event } = useSelector((state: StoreInterface) => state.eventHelper);

  const [showNoInternetPage, setShowNoInternetPage] = useState(false);
  const { online, apiReachable } = useNetworkStatus(showNoInternetPage);

  useEffect(() => {
    handleReduxSideEffects();
  }, [event]);

  // The API answers again: the failure is over, and the next one has to raise NO_INTERNET anew.
  useEffect(() => {
    if (showNoInternetPage && apiReachable) {
      setShowNoInternetPage(false);
    }
  }, [showNoInternetPage, apiReachable]);

  async function handleReduxSideEffects() {
    const { type } = event;

    if (!type) {
      return;
    }

    return new Promise((resolve, reject) => {
      switch (type) {
        case EventHelperTypes.NO_INTERNET:
          setShowNoInternetPage(true);
      }

      resolve(true);
      reject(false);
    }).then(HelperMethods.resetEventSideEffects);
  }

  function renderNoInternetConnectionPage() {
    return <NoInternetConnectionPage />;
  }

  function render(route: RoutesInterface): React.ReactNode {
    if (showNoInternetPage && !online) {
      return renderNoInternetConnectionPage();
    }

    switch (route?.protectedType) {
      case 'Auth':
        return (
          <AuthRoute>
            <CompanySlugObserver>{route.element}</CompanySlugObserver>
          </AuthRoute>
        );
      default:
        return <CompanySlugObserver>{route?.element}</CompanySlugObserver>;
    }
  }

  return render;
}
